<!-- Control actividad/proveedores -->

<template>
  <div class="expControlComp">
                     
    <div class="cab">{{ titulo }}</div>
    <div style="color:steelblue;">
      <v-sheet v-bind="$cfg.styles.marco" :height="height" style="display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:space-between">        
        <div class="columna">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    <template v-if="grupo> 1">
                      <uiText
                        style="width:300px"
                        v-bind="{...$input, ...$attrs}"
                        v-model="seleccion[2]"
                        :placeholder="seleccion[1]"
                        :disabled="disabled">
                      </uiText>
                    </template>

                    <template v-else>
                      <v-select
                        style="width:300px;white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;"                                 
                        v-bind="{...$select, ...$attrs}"
                        v-model="seleccion[2]"
                        :placeholder="seleccion[1]"
                        :items="dataAux"
                        :disabled="disabled"                        
                        item-value="val"
                        item-text="name"
                        dense
                        @change="changeSeleccion">
                      </v-select>                       
                    </template>
                  </th>

                  <th>
                    <v-icon color="red">{{'mdi-close-circle-outline'}}</v-icon>
                    <v-icon class="ml-2" color="green">{{'mdi-check-circle-outline'}}</v-icon>
                  </th>                                                            
                </tr>
              </thead>

              <tbody>
                <tr v-for="(valoracion, index) in valoraciones" :key="valoracion.name">
                  <td>{{ `${index+1} - ${valoracion.name}` }}</td>
                  <td>                     
                    <v-radio-group v-model="modelValoracion[index]" row class="mt-0" dense @change="changeValoracion(index, $event)">
                      <div v-for="ptipo in opcionesValoracion" :key="ptipo.id">
                        <v-radio
                          :label="ptipo.label"
                          :value="ptipo.id"
                          dense
                          :disabled="disabled">
                        </v-radio>
                      </div>
                    </v-radio-group>
                  </td>
                </tr>                  
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div class="columna">
          <v-textarea
            v-bind="$textarea"
            v-model="obs[2]"
            :label="obs[1]"
            no-resize
            rows="2"
            :disabled="disabled">
          </v-textarea>
        </div>       
      </v-sheet>
    </div>
  </div>
</template>



<script>
           
  export default {
    mixins: [],
    components: {},
    props: {
      grupo: { type:Number, default:1 },                        // grupo valoración: 0:Apd, 1:Funeraria, 2:Tanatorio, 
                                                                // 3:Flores, 4:Lapida, 5:Gestoría
                                                           
      seleccion: { type:Array, default:()=> [] },               // 
      val: { type:Array, default:()=> [] },                     // valoraciones radio buttons
      obs: { type:Array, default:()=> []},                      // observaciones
      titulo: { type:String, default:'' },
      dataAux: { type:[Array,String], default:()=> ''},         // array/text de selección de datos
      valoraciones: { type:Array, default:()=> []},             // array de valoraciones
      disabled: { type:Boolean, default: false },
      height: { type:String, default:'310px' },
    },

    data() {
      return {
        valueDefault:'0000000000',       
        opcionesValoracion:[          
          { id:'1', label: "" },
          { id:'2', label: "" },
        ],         
      };
    },


    
    methods: {

      // devuelve el string de valoraciones según el grupo recibido
      splitValoracion() {         
        let val= JSON.parse(JSON.stringify(this.val[2]));
        let multi= (this.valueDefault.length * this.grupo);        
        let arrVal= val.slice(multi, (multi + 10));
        
        return arrVal.split('');
      },


      // entra al cambiar una valoración y la modifica del schema
      changeValoracion(index, value) {
        let multi= (this.valueDefault.length * this.grupo);         
        let valChanged= this.val[2].substring(0, (multi + index)) + value + this.val[2].substring((multi + index) + 1);
        this.$set(this.val, 2, valChanged);        
      },


      // entra al cambiar el valor del combo de selección
      // si es un Apd llama a la función 'changeApd'
      // si es una Funeraría llama a la función 'changeFuneraria'      
      changeSeleccion(id) {
        if (this.grupo==0) this.changeApd(id);
        if (this.grupo==1) this.changeFuneraria(id);
      },


      // emite evento indicando que el apd ha cambiado
      changeApd(apd_ID) {
        console.log('apd_ID', apd_ID);
        let apd= this.dataAux.find(elem => elem.val== apd_ID);
        console.log('apd', apd);
        if (!apd) return;        
        
        this.$emit('changeSeleccion', apd.apd);
      },


      // emite evento indicando que la funeraria ha cambiado
      changeFuneraria(funeraria_ID) {
        let funeraria= this.dataAux.find(elem => elem.val== funeraria_ID);
        if (!funeraria) return;        
        
        this.$emit('changeSeleccion', funeraria.name);
      }
      
    },
    

    computed: {
      
      // devuelve el valor de una valoración según el grupo en el que se encuentra
      // si no se han recibido valoraciones, porque es un nuevo, las crea
      modelValoracion() { 
        if (!this.val[2]) this.$set(this.val, 2, ''.padStart((this.valueDefault.length*6), '0'));

        let split= this.splitValoracion();        
        return split;
      }

    },


  };
</script>



<style  scoped>
  .v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: 0px;
  }
</style>